import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const rumApplicationId = import.meta.env.REACT_APP_RUM_APPLICATION_ID;
const rumClientToken = import.meta.env.REACT_APP_RUM_CLIENT_TOKEN;

if (rumApplicationId && rumClientToken) {
  datadogLogs.init({
    clientToken: rumClientToken,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  datadogRum.init({
    applicationId: rumApplicationId,
    clientToken: rumClientToken,
    site: 'datadoghq.com',
    service: 'geocoder',
    env: import.meta.env.REACT_APP_RUM_ENV,
    version: import.meta.env.REACT_APP_RUM_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [{ match: /https:\/\/dataorch.*\.gojitsu\.com/, propagatorTypes: ['datadog'] }],
  });
  datadogRum.startSessionReplayRecording();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
